import { Resource } from './resource';

export type MeasureHeightState = {
  open: boolean;
  resource: Resource<{ height?: string; stddev?: number }>;
};

export enum MeasureHeightActionTypes {
  MEASURE_HEIGHT_OPEN = 'MEASURE_HEIGHT_OPEN',
  MEASURE_HEIGHT_CLOSE = 'MEASURE_HEIGHT_CLOSE',

  MEASURE_HEIGHT_START = 'MEASURE_HEIGHT_START',
  MEASURE_HEIGHT_COMPLETE = 'MEASURE_HEIGHT_COMPLETE',
  MEASURE_HEIGHT_ERROR = 'MEASURE_HEIGHT_ERROR',

  MEASURE_HEIGHT_CHANGE_HEIGHT = 'MEASURE_HEIGHT_CHANGE_HEIGHT',
  MEASURE_HEIGHT_STORE_HEIGHT = 'MEASURE_HEIGHT_STORE_HEIGHT',
  MEASURE_HEIGHT_STORE_HEIGHT_COMPLETE = 'MEASURE_HEIGHT_STORE_HEIGHT_COMPLETE',
}

export type MeasureHeightAction =
  | { type: MeasureHeightActionTypes.MEASURE_HEIGHT_OPEN }
  | { type: MeasureHeightActionTypes.MEASURE_HEIGHT_CLOSE }
  | {
      type: MeasureHeightActionTypes.MEASURE_HEIGHT_START;
      serialNumber: string;
    }
  | {
      type: MeasureHeightActionTypes.MEASURE_HEIGHT_COMPLETE;
      height: number;
      stddev: number;
    }
  | { type: MeasureHeightActionTypes.MEASURE_HEIGHT_ERROR; error: Error };
